import ReactDOM from 'react-dom';
import {HelmetProvider} from 'react-helmet-async';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import 'config/env';
import {persistorStore, store} from './redux/store';
import {SidebarProvider} from 'contexts/SidebarContext';
import * as serviceWorker from 'serviceWorker';
import App from 'App';
import './i18n/config';
import {ToastContainer} from 'react-toastify';

import 'nprogress/nprogress.css';
import 'react-toastify/dist/ReactToastify.css';
import {PersistGate} from 'redux-persist/integration/react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/global.scss';

import ErrorBoundary from 'components/error-boundary/ErrorBoundary';

import TimeAgo from 'javascript-time-ago';

import en from 'javascript-time-ago/locale/en';
import de from 'javascript-time-ago/locale/de';
import {QueryClientProvider} from '@tanstack/react-query';
import queryClient from './queryClient';

TimeAgo.addDefaultLocale(en);
TimeAgo.addLocale(de);

ReactDOM.render(
  <HelmetProvider>
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistorStore}>
          <SidebarProvider>
            <QueryClientProvider client={queryClient}>
              <BrowserRouter>
                <App />
                <ToastContainer />
              </BrowserRouter>
            </QueryClientProvider>
          </SidebarProvider>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </HelmetProvider>,
  document.getElementById('root'),
);

serviceWorker.unregister();
